<template>
  <div>
    <a-result status="404" title="404" sub-title="找不到该页面">
      <template #extra>
        <a-button type="primary" @click="goHome"> 返回首页 </a-button>
      </template>
    </a-result>
  </div>
</template>

<script>
export default {
  data() {
    return {
    };
  },
  created() {
  },
  methods: {
    goHome() {
      this.$router.replace("/train/project-list");
    },
  },
};
</script>

<style lang="scss" scoped>

</style>